import jwtDecode from 'jwt-decode';

/* eslint-disable no-param-reassign */

/** Refresh this many ms before Cognito exp (backend allows 30s skew). */
export const TOKEN_REFRESH_BUFFER_MS = 60 * 1000;

export function decodeAccessToken(token) {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function isTokenExpired(token, bufferMs = TOKEN_REFRESH_BUFFER_MS) {
  const decoded = decodeAccessToken(token);
  if (!decoded?.exp) return true;
  return Date.now() >= (decoded.exp * 1000) - bufferMs;
}

export function attachAuthHeader(config, token) {
  if (!config.headers) {
    config.headers = {};
  }
  config.headers.auth = token;
  return config;
}

export function isMapfreRequest(config) {
  const url = config?.url || '';
  return url.includes('/gis/mapfre/') || url.includes('mapfre/policy/issue');
}

export function isGuestAuthRequest(config) {
  const url = config?.url || '';
  const isPaymentAPI = url.includes('/payment/')
    || url.includes('/payments/')
    || url.includes('stk/request')
    || url.includes('payment/query');
  // Guest Get Quote: quotation APIs, motor vehicle lookup, email share
  const isQuotationAPI = url.includes('/customer/quotation/');
  const isVehicleLookup = url.includes('/customer/gis/vehicles/');
  const isEmailShare = url.includes('/customer/digital-notification/');
  return isPaymentAPI || isQuotationAPI || isVehicleLookup || isEmailShare;
}

export function buildSignInReturnUrl(cookie, userTypeKey) {
  const isAgent = cookie.get(userTypeKey) === 'agent';
  const currentUrl = window.location.href;
  const isCustomerDashboard = currentUrl.includes('/dashboard')
    && !currentUrl.includes('agent-dashboard')
    && !currentUrl.includes('/agent/');
  if (isAgent && isCustomerDashboard) {
    return `${window.location.origin}/agent-dashboard`;
  }
  return currentUrl;
}
